<template>
  <ValidationObserver v-slot="{ invalid, validated, passes }">
    <v-card>
      <v-card-title>Update Password</v-card-title>
      <v-card-text>
        <v-form>
          <ValidationProvider
            v-slot="{ errors, valid }"
            name="oldPassword"
            rules="required|min:8|verify_password"
          >
            <v-text-field
              v-model="oldPassword"
              :error-messages="errors"
              label="Old password"
              type="password"
              counter
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors, valid }"
            name="password"
            :rules="{required: true,min:8,verify_password: true,new_password: oldPassword}"
            vid="newPassword"
          >
            <v-text-field
              
              v-model="password"
              :error-messages="errors"
              label="New password"
              :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="e1 ? 'password' : 'text'"
              counter
              @click:append="() => (e1 = !e1)"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors, valid }"
            name="confirmPassword"
            rules="required|min:8|verify_password|confirmed:newPassword"
          >
            <v-text-field
              v-model="confirmPassword"
              label="Confirm your password"
              :error-messages="errors"
              type="password"
              counter
              @keyup.enter="passes(submit)"
            />
          </ValidationProvider>
          <div v-if="errs.length" class="error-callback">
            <ul>
              <li v-for="error in errs" :key="error">{{ error }}</li>
            </ul>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="brand-green darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn
          id="color-override"
          :loading="loader"
          :disabled="invalid || !validated"
          class="submit-btn"
          text
          @click.prevent="passes(submit)"
        >Update</v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>

import { ValidationObserver, ValidationProvider } from "vee-validate";
import Auth from '@/services/Auth';

import { Logger } from "aws-amplify";
const logger = new Logger("UserProfile");

export default {
  name: 'UpdatePassword',
  components: { 
    ValidationObserver, 
    ValidationProvider 
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      e1: true,
			oldPassword: "",
			password: "",
			confirmPassword: "",
			errs: [],
      errors: []
    }
  },
  watch: {
    oldPassword: function() {
      this.clearErrors();
    },
    password: function() {
      this.clearErrors();
    },
    confirmPassword: function() {
      this.clearErrors();
    }
  },
  methods: {
    submit() {
      this.loader = true;

      Auth.resetPassword(this.oldPassword, this.password)
      .then(res => {
        logger.info('password updated', res)
        this.errs = [];
        this.loader = false;

        this.$emit('hideForm', true);

        setTimeout(async () => {
          await Auth.SignOut();
          location.replace(
            location.protocol +
              "//" +
              process.env.VUE_APP_auth_domain
          );
        }, 2000);
      })
      .catch(err => {
        this.loader = false;
        this.errs = [err];
      })
    },
    clearErrors() {
      if (this.errs.length > 0) {
        this.errs = [];
      }
    },
    cancel() {
      this.$emit('hideForm', false);
      this.oldPassword = "";
      this.password = "";
      this.confirmPassword = "";
    }
  }
}
</script>

<style lang="scss">
  .brand-green {
    color: #24AB80 !important;
  }
  .submit-btn {
    background-color: #24AB80 !important;
  }
  .error-callback {
    ul,li {
      list-style: none;
      color: red;
    }
  }
  #color-override {
    color: white !important;
  }
</style>